import { render, staticRenderFns } from "./vuex-date-range.vue?vue&type=template&id=2afc4204"
import script from "./vuex-date-range.vue?vue&type=script&lang=js"
export * from "./vuex-date-range.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports